<template>
  <div class="inner" style="padding: 20px 0;">
    <div style="display: flex;flex-direction:column;align-items: normal;padding-bottom: 40px">
      <img :src="pathUrl" style="max-height: 100%;max-width: 100%">
    </div>
  </div>


</template>

<script>
import { jump, getUser } from '@/untils/auth'
  export default {
    name: "indexIntro",
    components: {},
    data() {
      return {
        pathUrl: '',
      }
    },
    created() {
      // this.current = this.$route.query.current;
      // this.name = this.$route.query.searchtext;
      this.pathUrl = this.$route.query.pathUrl;

    },
  };
</script>
<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Education/indexIntro.vue